import * as authorActions from './author/author.actions';
import * as serieActions from './serie/serie.actions';
import * as bookActions from './book/book.actions';

export const entitiesActions = {
  ...authorActions,
  ...serieActions,
  ...bookActions,
};
